import { botFlowSelector } from '../flow/selectors/botFlowSelector'
import { actions } from './socketServerSlice'
import { FeedbotMiddleware, isThunk } from '../types'
import { emitBotState } from './socketServerConnectionService'
import { latestVersionFlowSelector } from '../../features/serverBots/selectors'
import {
  createBotState,
  hasChangesToEmit,
  isAfterSaveAction,
  isChangingVersion,
  isDifferentVersion,
  isEditingAllowed
} from './diffMiddlewareService'
import { cliLog } from '../../lib/cliLog'

export const diffMiddleware: FeedbotMiddleware = store => next => action => {
  if (isThunk(action)) {
    return next(action)
  }

  const previousFlow = botFlowSelector(store.getState())
  const previousOriginalVersion = latestVersionFlowSelector(store.getState())
  const result = next(action)
  const nextFlow = botFlowSelector(store.getState())
  const nextOriginalVersion = latestVersionFlowSelector(store.getState())

  if (action.type === 'originalState/resetVersion') {
    cliLog(`NO DIFF - resetting version`)
    return result
  }

  if (isDifferentVersion(nextOriginalVersion, nextFlow)) {
    cliLog(`NO DIFF - version mismatch ${nextOriginalVersion?.version} vs. ${nextFlow?.version}`)
    return result
  }

  if (isChangingVersion(previousFlow, nextFlow)) {
    cliLog(`NO DIFF - changing version ${previousFlow?.version} to ${nextFlow?.version}`)
    return result
  }

  if (!isEditingAllowed(store.getState())) {
    return result
  }

  if (previousOriginalVersion !== nextOriginalVersion) {
    cliLog(`NO DIFF - original version changed`)
    return result
  }

  if (!hasChangesToEmit(previousFlow, nextFlow, action.type)) {
    return result
  }

  if (isAfterSaveAction(action.type)) {
    return result
  }

  const newBotState = createBotState(store.getState())

  if (!newBotState) {
    return result
  }

  next(actions.newBotState(newBotState))
  emitBotState(newBotState)

  return result
}
